import React from "react";
import FormularioVentaFacturas from "js/components/FormularioVentaFacturas";

function ProductoFactura(props) {
  return <FormularioVentaFacturas />;
}

export default ProductoFactura;
